import { applyAuthStateLoggedIn } from '../../core/auth-state';
import { qsa, on } from '../../core/dom';
import type { NavModuleInit } from '../../core/types';

interface PopoverHandle {
  destroy(): void;
  isOpen(): boolean;
}

const init: NavModuleInit = ({ state, bus }) => {
  const joinButtons = qsa<HTMLAnchorElement | HTMLButtonElement>(
    '[data-gn-trigger="join"], [data-testid="global-nav-join-button-desktop"]',
  );
  if (joinButtons.length === 0) return;

  let popover: PopoverHandle | null = null;

  const openPopover = async (anchor: HTMLElement) => {
    popover?.destroy();
    try {
      // @ts-ignore — vanilla subpath emitted by user-login build
      const mod = await import('@finder/user-login/lib/vanilla/social-popover');
      popover = mod.mountSocialPopover({
        anchor,
        loginLink: `${state.domain}/user-profile/sign-up`,
        accountCreateFlow: 'web_nav_menu',
        heading: 'Finder free and exclusive deals',
        onSuccess: (method: 'google' | 'apple') => {
          bus.emit('analytics:click', { label: `social-popover:success:${method}` });
          applyAuthStateLoggedIn(window.finderGlobalNav?.registry);
        },
        onFail: (err: Error) => {
          bus.emit('analytics:click', { label: `social-popover:fail:${err.message}` });
        },
        onClose: () => {
          popover = null;
        },
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[global-nav-v2] social-popover failed to load, falling back to redirect', err);
      location.href = `${state.domain}/user-profile/sign-in`;
    }
  };

  const onJoinClick = (e: Event) => {
    e.preventDefault();
    void openPopover(e.currentTarget as HTMLElement);
  };

  const offJoins = joinButtons.map((b) => on(b, 'click', onJoinClick));

  return {
    destroy: () => {
      offJoins.forEach((off) => off());
      popover?.destroy();
    },
  };
};

export default init;
